import { Incognito, Users } from "components/icons/generated";
import { BillingTier } from "types/generated";

import {
  ADDITIONAL_FEATURES_BY_TIER,
  BASE_INFO_BY_TIER,
  DETAILS_BY_TIER,
  UPGRADE_BOX_BY_TIER,
} from "./constants";

export const PRE_OCTOBER_2026_UPGRADE_MARKETING_TIERS: BillingTier[] = [
  BillingTier.V5Starter,
  BillingTier.V5StarterPlus,
  BillingTier.V5Business,
  BillingTier.V5Enterprise,
  BillingTier.V5EnterprisePlus,
];

export const PRE_OCTOBER_2026_BASE_INFO_BY_TIER: typeof BASE_INFO_BY_TIER = {
  ...BASE_INFO_BY_TIER,
  [BillingTier.V5StarterPlus]: {
    title: "Annual plan starting from",
    price: "$20,000 / y",
    description:
      "For growing teams looking to optimize team workflows with infrastructure automation.",
  },
};

export const PRE_OCTOBER_2026_DETAILS_BY_TIER: typeof DETAILS_BY_TIER = {
  ...DETAILS_BY_TIER,
  [BillingTier.V5StarterPlus]: [
    { icon: Users, text: "Unlimited Users" },
    { icon: Incognito, text: "1 Private Worker" },
  ],
  [BillingTier.V5Business]: [
    { icon: Users, text: "Unlimited Users" },
    { icon: Incognito, text: "3 Private Workers" },
  ],
  [BillingTier.V5Enterprise]: [
    { icon: Users, text: "Unlimited Users" },
    { icon: Incognito, text: "5-30 Private Workers" },
  ],
  [BillingTier.V5EnterprisePlus]: [
    { icon: Users, text: "Unlimited Users" },
    { icon: Incognito, text: "12-30 Private Workers" },
  ],
};

export const PRE_OCTOBER_2026_ADDITIONAL_FEATURES_BY_TIER: typeof ADDITIONAL_FEATURES_BY_TIER = {
  ...ADDITIONAL_FEATURES_BY_TIER,
  [BillingTier.V5StarterPlus]: [
    { text: "Drift Detection", infoTooltip: "Detect drift and optionally remediate it." },
  ],
  [BillingTier.V5Business]: [
    {
      text: "Blueprints",
      infoTooltip:
        "Templates for a stack and its configuration (even policy, contexts, and cloud integration attachments).",
    },
    { text: "Templates" },
    {
      text: "Advanced Scheduling",
      infoTooltip: "Scheduled tasks and stack auto deletion based on cron.",
    },
    {
      text: "Private Provider Registry",
      infoTooltip: "Unlocks the ability to host and share providers.",
    },
    {
      text: "Targeted Replans",
      infoTooltip: "Enables you to have targeted runs in your workflow.",
    },
    {
      text: "Dedicated Slack Support Channel",
      infoTooltip: "Shared Slack channel between you and your dedicated CSM.",
    },
    { text: "Dedicated Customer Success Manager" },
    { text: "Silver Support + CSM" },
  ],
};

export const PRE_OCTOBER_2026_UPGRADE_BOX_BY_TIER: typeof UPGRADE_BOX_BY_TIER = {
  ...UPGRADE_BOX_BY_TIER,
  [BillingTier.V5StarterPlus]: {
    title: "Upgrade available:",
    items: ["Additional Private Worker"],
  },
};
